import { NEWS_BOOKMARKS_ROUTES } from '../shared/utils/routes'
import createAppRouter from './create_router'

const newsBookmarksRouter = createAppRouter(NEWS_BOOKMARKS_ROUTES, {
  redirect: true,
  history: true,
})

export default newsBookmarksRouter
